import { render, staticRenderFns } from "./EditContractComponent.vue?vue&type=template&id=052013a9&scoped=true"
import script from "./EditContractComponent.vue?vue&type=script&lang=js"
export * from "./EditContractComponent.vue?vue&type=script&lang=js"
import style0 from "./EditContractComponent.vue?vue&type=style&index=0&id=052013a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052013a9",
  null
  
)

export default component.exports